import {
  invokeShopifyCheckoutCreate,
  invokeShopifyCartCreate,
} from "~/utils/shopify";
import { getCurrencyByLocale } from "~/utils/locale";
export default {
  methods: {
    async cartCheckout(locale: any, lineItem: any, cartItems: any, store: any, discountCode: any, attributes: any) {
      // const checkoutResponse = await invokeShopifyCheckoutCreate(
      //   this.generateCheckOutItemList(lineItem.bouquest, discountCode, attributes),
      //   getCurrencyByLocale(locale.toLowerCase())
      // );
      const checkoutResponse = await invokeShopifyCartCreate(
        this.generateCheckOutItemList(lineItem.bouquest, discountCode, attributes),
        getCurrencyByLocale(locale.toLowerCase())
      );
      const checkout = checkoutResponse?.data?.cartCreate?.cart;
      if (checkout) {
        const checkoutId = checkout.id;
        const checkoutPage = checkout.checkoutUrl;
          // clear cart items
          cartItems = [];
          store.dispatch("lineItems/CLEAR_CART_ITEMS");
          sessionStorage.removeItem("cartItems");
          if (locale.toLowerCase() == "fr-ca") {
            window.open(checkoutPage + "&locale=fr", "_self");
          } else {
            console.log('checkoutPage, "_self"', checkoutPage);
            window.open(checkoutPage, "_self");
          }
      } else {
        console.error('lineItem input', lineItem, ' discountCode', discountCode)
        console.error('checkoutResponse object', checkoutResponse)
        console.error('checkout object', checkout)
        console.error(`Error creating checkout: ${checkoutResponse}`);
      }
    },
    generateCheckOutItemList(lineItemsMap: any, discountCode: string, attributes: any): any {
      let mappedAttributes = Object.keys(attributes).map((key) => {return {"key": key, "value": attributes[key]}});
      let utmCampaign = sessionStorage.getItem("utm-campaign")
      if(utmCampaign && utmCampaign.length > 0){
        mappedAttributes.push({"key": "utm-campaign", "value": utmCampaign})
      }
      const sellingPlanExceptionTypes = ["Vase", "Gift-adds", "Card"];
      let cartItemsInput: { cartInput: { lines: any[], discountCodes: any[], attributes: any[] } } = {"cartInput":{"lines": [], "discountCodes": [discountCode], "attributes": mappedAttributes} };
      let items = []
      for(const [key, value] of Object.entries(lineItemsMap)) {
        let sellingPlan = this.findOrderSellingPlan(value);
        for(const item of value as any ){
          let orderItem: any = {
            "quantity": parseInt(item.quantity),
            "merchandiseId": item.id,
            "attributes": item.customAttributes
            .filter((attr: any) => attr.value && attr.value.length > 0 && attr.value.trim().length > 0)
            .map((attr: any) => {
              return {
                key: attr.key,
                value: attr.value
              };
            })
          }

          if (sellingPlan && !sellingPlanExceptionTypes.includes(item.productType)) {
            orderItem.sellingPlanId = sellingPlan;
          }

          items.push(orderItem)
        }
      }
      cartItemsInput.cartInput.lines = items;
      return cartItemsInput;
    },
    findOrderSellingPlan(items: any) {
      let sellingPlan = null;
      for(const item of items ){
        if (item.variant && item.variant.selectedSellingPlan && item.variant.selectedSellingPlan.id) {
          sellingPlan = item.variant.selectedSellingPlan.id
          break;
        }
      }
      return sellingPlan;
    }
  },
};
